import { ROUTE_INDEX_ADVISORY_PROTOCOL, ROUTE_NAME_ADVISORY_PROTOCOL } from '@/config/constants'
import { PartnerHelper, LogHelper, RouteHelper } from '@/helpers'

export default [
  {
    beforeEnter: (_to, _from, next) => {
      const partnerData = RouteHelper.getPartner()
      const isBroker = PartnerHelper.isBroker(partnerData)
      if (isBroker) {
        next()
      } else {
        LogHelper.error(['Trying to access advisory protocol with wrong salesPartnerType', partnerData])
        next(false)
      }
    },

    component: () =>
      import(/* webpackChunkName: "screen-advisory-protocol" */ '@/modules/Configurator/screens/AdvisoryProtocol'),
    meta: {
      headerDisabled: true,
      index: ROUTE_INDEX_ADVISORY_PROTOCOL,
      navigation: false,
      secured: true,
    },
    name: ROUTE_NAME_ADVISORY_PROTOCOL,
    path: '/advisory-protocol',
  },
]
